<div class="row lmu-container">
    <span class="col-1 aoc-tooltips" *ngIf="!defaultRestoring">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Restore default</div>
            </div>
        </ng-template>
    </span>
    <span class="col-1 aoc-tooltips" *ngIf="defaultRestoring">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Default</div>
            </div>
        </ng-template>
    </span>

    <div class="col-9"></div>
    <div class="col-1"></div>
</div>
<div class="row lmu-container paramter-custom">
    <div id="LuminaireInfo-ContentFormatID-Text" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">Content format ID :</div>
    <div class="col-6 custom-button">
        <select id="LuminaireInfo-ContentFormatID-dropdown" class="form-control lum-text dropdown-select"
                [ngClass]="{'showingError': hasContentFormatError}"
                [(ngModel)]="selectedVersion"
                (change)="onChangeVersion($any($event.target).selectedIndex)">
            <option *ngFor="let displayVersion of displayVersions let i = index" [value]="displayVersion" >
                {{ displayVersion }}
            </option>
        </select>
        <div *ngIf="hasContentFormatError" id="LuminaireInfo-ContentFormatID-error" class="content-format-error-msg">
            Wrong content format id, select the correct one from dropdown
        </div>
    </div>
</div>
<div *ngFor="let param of filedName; let i = index;">
    <div class="row lmu-container paramter-custom" *ngIf="param == 'OemGtin'">
        <div id = "OemGtin" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text ">{{columnList1[param]}}
            :</div>
        <div class="col-6 custom-button">
            <input id = "OemGtinValue" placeholder="" [ngClass]="{'showingError': errorPattern[param]}" type="text"
                   (input)="onOemGtinInput(param)" (compositionend)="onOemGtinCompositionEnd($event, param)" (paste)="onPaste($event, param)" [(ngModel)]="ngModelval[param]"
                   class="form-control lum-text" name="param">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'OemIdentification'">
        <div id="OemIdentification" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button d-flex align-items-center">
            <input id="OemIdentificationValue" [ngClass]="{'showingError': errorPattern[param],'disabled-textbox':useDeviceID}"
                [disabled]="useDeviceID" type="text" class="form-control lum-text oem-identification-input" name="param"
                [(ngModel)]="ngModelval[param]" (input)="onOemIdentificationInput(param)" (compositionend)="onOemIdentificationCompositionEnd($event, param)" (paste)="onOemIdentificationPaste($event, param)" />
            <span *ngFor="let item of filedName">
                <div class="d-flex align-items-center" *ngIf="item === 'UseDeviceUid'" style="margin-left: -0.9em;">
                    <span class="mr-2">{{columnList1['UseDeviceUid']}}</span>
                    <input id="UseDeviceUid" type="checkbox" class="useDeviceCheck" [checked]="UseDeviceUidChecking"
                        (change)="checkboxChanged($event)">
                </div>
            </span>
        </div>
    </div>


  <div *ngIf="param == 'LuminaireManufactureYear'" class="row lmu-container paramter-custom">
        <div id = "LuminaireManufactureYear" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
        </div>
        <div class="col-6 custom-button">
            <input id = "LuminaireManufactureYearValue" placeholder="" minlength="1" maxlength="2" [disabled]="dynamIndicator"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireManufactureWeek'">
        <div id = "LuminaireManufactureWeek" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
        </div>
        <div class="col-6 custom-button d-flex align-items-center">
            <input id = "LuminaireManufactureWeekValue" placeholder="" minlength="1" maxlength="2" [disabled]="dynamIndicator"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text manufacture-week-input" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <div style="margin-left: -0.9em;">
                <span class="mr-2">{{columnList1['UseDynamicDateIndicator']}}</span>
                <input id = "UseDynamicDateIndicatorValue" type="checkbox" class="useDateCheck" [checked]="UseDynamicDateIndicator" id="UseDynamicDateIndicator"
                (change)="checkboxChanged($event)">
            </div>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'NominalInputPower'">
        <div id = "NominalInputPower" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "NominalInputPowerValue" appOnlynumber maxlength="{{properties[param]['maxLength']}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)" (focusout)="otherVersionFields(param)">
            <span [ngClass]="{'myStyle': 0 !== i % 2}" class="col-1 unit-lumin">W</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'PowerMinDim'">
        <div id = "PowerMinDim" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "PowerMinDimValue" appOnlynumber maxlength="{{properties[param]['maxLength']}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class=" form-control lum-text"
                name="param" [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span class="col-1 unit-lumin" [ngClass]="{'myStyle': 0 !== i % 2}">W</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'MinAcMainsVoltage'">
        <div id = "MinAcMainsVoltage" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "MinAcMainsVoltageValue" appOnlynumber (focusout)="otherVersionFields(param)" maxlength="{{properties[param]['maxLength']}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class=" form-control lum-text"
                name="param" [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span class="col-1 unit-lumin" [ngClass]="{'myStyle': 0 !== i % 2}">V</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'MaxAcMainsVoltage'">
        <div id = "MaxAcMainsVoltage" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "MaxAcMainsVoltageValue" appOnlynumber (focusout)="otherVersionFields(param)" maxlength="{{properties[param]['maxLength']}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class=" form-control lum-text"
                name="param" [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span class="col-1 unit-lumin" [ngClass]="{'myStyle': 0 !== i % 2}">V</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'NominalLightOutput'">
        <div id = "NominalLightOutput" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "NominalLightOutputValue" appOnlynumber (focusout)="otherVersionFields(param)" maxlength="{{properties[param]['maxLength']}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span class="col-1 unit-lumin" [ngClass]="{'myStyle': 0 !== i % 2}">Lm</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'CRI'">
        <div id = "CRI" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "CRIValue" appOnlynumber maxlength="{{properties[param]['maxLength']}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">

        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'CCT'">
        <div id = "CCT" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "CCTValue" appOnlynumber (focusout)="otherVersionFields(param)" [disabled]="disableCCT"
                maxlength="{{properties[param]['maxLength']}}" [ngClass]="{'showingError': errorPattern[param]}"
                type="text" class=" form-control lum-text" name="param" [(ngModel)]="ngModelval[param]"
                (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span class="col-1 unit-lumin" [ngClass]="{'myStyle': 0 !== i % 2}">K</span>
            <div class="col-2 custom-implmented-checkbox blockCss" >&nbsp;&nbsp;&nbsp; Part 209
                implemented
                <input [checked]="implemented_209" type="checkbox" class="useDateCheck implemented" id="implemented_209"
                    (change)="partImplemented($event)">
            </div>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'DistributionType'">
        <div id = "DistributionType" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id = "DistributionTypeValue" appOnlynumber (focusout)="otherVersionFields(param)" maxlength="{{properties[param]['maxLength']}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireColor'">
        <div id = "LuminaireColor" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
            <input id = "LuminaireColorValue" maxlength="{{checkMaxString[param]}}" placeholder=""
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireIdentification'">
        <div id="LuminaireIdentification" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
            <input id="LuminaireIdentificationValue" maxlength="{{checkMaxString[param]}}" placeholder=""
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LightDistribution'">
        <div id = "LightDistribution" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
            <input id = "LightDistributionValue" maxlength="{{checkMaxString[param]}}" placeholder=""
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'OemName'">
        <div id = "OemName" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
          <input id="OemNameValue" maxlength="{{checkMaxString[param]}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'CustomerStockingNumber'">
        <div id = "CustomerStockingNumber" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
          <input appOnlynumber id="CustomerStockingNumberValue" maxlength="{{checkMaxString[param]}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LampCurrentAt100PercentageArcPower'">
        <div id = "LampCurrentAt100PercentageArcPower" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :</div>
        <div class="col-6 custom-button">
            <input appOnlynumber id = "LampCurrentAt100PercentageArcPowerValue"
                   (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                   (paste)="onPaste($event, param)" [(ngModel)]="ngModelval[param]" maxlength="{{checkMaxString[param]}}">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'CustomerUseCharacters'">
        <div id = "CustomerUseCharacters" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
            <input id = "CustomerUseCharactersValue" maxlength="{{checkMaxString[param]}}"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'AdditionalInfo'">
        <div id = "AdditionalInfo" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
            <input id = "AdditionalInfoValue" maxlength="{{checkMaxString[param]}}"
                [ngClass]="{'showingError': errorPattern[param],'disabled-textbox':useDeviceID}" type="text"
                class="form-control lum-text" name="param" [(ngModel)]="ngModelval[param] " (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>

    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireManufactureDate'">
        <div id="LuminaireManufactureDate" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button d-flex align-items-center">
            <input id="LuminaireManufactureDateValue" placeholder="yyww" [disabled]="dynamIndicator" [ngClass]="{'showingError': errorPattern[param]}"
                type="text" maxlength="4" class="form-control lum-text manufacture-date-input" name="param" [(ngModel)]="ngModelval[param]"
                (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span class="mr-2">{{columnList1['UseDynamicDateIndicator']}}</span>
            <input type="checkbox" class="useDateCheck" [checked]="UseDynamicDateIndicator" id="UseDynamicDateIndicator"
                (change)="checkboxChanged($event)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireManufactureName'">
        <div id="LuminaireManufactureName" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
            <input id="LuminaireManufactureNameValue" type="text" maxLength="{{checkMaxString[param]}}" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireStyle'">
        <div id="LuminaireStyle" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}}
            ({{checkMaxString[param]}}) :</div>
        <div class="col-6 custom-button">
            <input id="LuminaireStyleValue" maxlength="{{checkMaxString[param]}}" [ngClass]="{'showingError': errorPattern[param]}" type="text"
                class="form-control lum-text" name="param" [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
        </div>
    </div>
</div>
<div *ngFor="let param of filedName; let i=index;">
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireLightSource'">
        <div id="LuminaireLightSource" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id="LuminaireLightSourceValue" appOnlynumber (focusout)="otherVersionFields(param)"
                [ngClass]="{'showingError': errorPattern[param]}" type="number" class="form-control lum-text"
                name="param" [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'LuminaireColorCode'">
        <div id="LuminaireColorCode" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id="LuminaireColorCodeValue" appOnlynumber (focusout)="otherVersionFields(param)"
                [ngClass]="{'showingError': errorPattern[param]}" type="number" class="form-control lum-text"
                name="param" [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)">
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'InputpowerBandNominal'">
        <div id="InputpowerBandNominal" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id="InputpowerBandNominalValue" appOnlynumber (focusout)="otherVersionFields(param)"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class=" form-control lum-text"
                name="param" [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span id="InputpowerBandNominal-unit" class="col-1 unit-lumin" [ngClass]="{'myStyle': 0 !== i % 2}">%</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'InputpowerBandPhysicalMin'">
        <div id="InputpowerBandPhysicalMin" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id="InputpowerBandPhysicalMinValue" appOnlynumber (focusout)="otherVersionFields(param)"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span id="InputpowerBandPhysicalMin-unit" class="col-1 unit-lumin" [ngClass]="{'myStyle': 0 !== i % 2}">%</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'DimlevelPf90'">
        <div id="DimlevelPf90" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id="DimlevelPf90Value" appOnlynumber appOnlynumber (focusout)="otherVersionFields(param)"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span id="DimlevelPf90-unit" class="col-1 unit-lumin blockCss" [ngClass]="{'myStyle': 0 !== i % 2}">(=0-100%)</span>
        </div>
    </div>
    <div class="row lmu-container paramter-custom" *ngIf="param == 'DimlevelPf70'">
        <div id="DimlevelPf70" class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text">{{columnList1[param]}} :
        </div>
        <div class="col-6 custom-button">
            <input id="DimlevelPf70Value" appOnlynumber (focusout)="otherVersionFields(param)"
                [ngClass]="{'showingError': errorPattern[param]}" type="text" class="form-control lum-text" name="param"
                [(ngModel)]="ngModelval[param]" (input)="valueChanged(param)" (compositionend)="onCompositionEnd($event, param)">
            <span id="DimlevelPf70-unit" class="col-1 unit-lumin blockCss" [ngClass]="{'myStyle': 0 !== i % 2}">(=0-100%)</span>
        </div>
    </div>
</div>
<div class="configuration-background">
    <div class="" *ngFor="let param of filedName">
        <div class="row check-container" *ngIf="param == 'IndependentOccupancySensor'">
            <div class="col-8 bottom-container">
                Luminaire configuration
            </div>
        </div>
        <div class="row check-container" *ngIf="param == 'IndependentOccupancySensor'">
            <div class="col-1 bottom-container"></div>
            <div class="col-5 bottom-container">{{columnList1[param]}}</div>
            <div class="col-2 bottom-container">
                <input type="checkbox" id="IndependentOccupancySensor" name="param" [checked]="ngModelval[param]"
                    [(ngModel)]="ngModelval[param]" (change)="checkboxChanged($event)">
            </div>
        </div>
        <div class="row check-container" *ngIf="param == 'LsiDevicePresent'">
            <div class="col-1 bottom-container"></div>
            <div class="col-5 bottom-container">{{columnList1[param]}} </div>
            <div class="col-2 bottom-container">
                <input type="checkbox" id="LsiDevicePresent" name="param" [checked]="ngModelval[param]"
                    [(ngModel)]="ngModelval[param]" (change)="checkboxChanged($event)" />
            </div>
        </div>
    </div>
</div>
